import { IS_MOBILE, Is_TAB } from "const/common";
import Image from "next/image";
import { useEffect, useState } from "react";

const Services = () => {
  const [isMobile, setIsMobile] = useState();
  const [isTab, setIsTab] = useState();

  useEffect(() => {
    setIsMobile(IS_MOBILE(600));
    setIsTab(Is_TAB(1079));
  }, []);

  return (
    <>
      <div className="lg:p-16">
        <div className="md:px-16 sticky top-24 -z-10">
          <h2 className="text-3xl md:text-4xl xl:text-7xl xl:leading-snug font-medium text-center">
            <span className="font-ubuntu">
              Solutions provided <br /> for every Service Provider
            </span>
          </h2>
        </div>
        <div>
          {isMobile || isTab ? (
            <div className="text-center">
              <Image
                alt="Know Your Customer App open on the Phone, different service vendors in the frame."
                src={"/assets/case-study/kyc/service-responsive.webp"}
                width={1062}
                height={1378}
              />
            </div>
          ) : (
            <div className="py-24 md:p-12 xl:py-24 xl:px-16 text-center">
              <Image
                alt="Know Your Customer App open on the Phone, different service vendors in the frame."
                src={"/assets/case-study/kyc/services.webp"}
                width={3775}
                height={2212}
              />
            </div>
          )}
        </div>

        <div className="p-16 md:p-8 xl:p-16"></div>
        <div className="py-16 px-4 md:px-8 xl:px-24"></div>
      </div>
    </>
  );
};

export default Services;
